<template>
  <div>
    <v-btn @click="dialog=!dialog" color="green"><v-icon>add</v-icon></v-btn>
    <v-dialog
        max-width="490"
        v-model="dialog"
    >
      <v-card>
        <v-card-title class="headline">Dodawanie nowego szablonu</v-card-title>
        <v-card-text>
          <CalendarData v-on:updated="createData=$event.data"/>
        </v-card-text>
        <v-card-actions>
          <v-btn
              @click="createTemplate()"
              color="green darken-1"
              text
          >
            Dodaj
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              @click="dialog = false"
              color="red darken-1"
              text
          >
            Anuluj
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-data-table
        :headers="headers"
        :items="calendarTemplates"
        class="elevation-1"
        hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.name_template }}</td>
        <td class="text-xs">{{ props.item.description_template }}</td>
        <td class="text-xs">{{ props.item.date_template }}</td>
        <td class="text-xs">{{ props.item.time_template }}</td>
        <td class="text-xs">{{ props.item.color }}</td>
        <td class="justify-center layout px-0">
          <v-btn @click="deleteTemplate(props.item.id)" class="mx-0" icon>
            <v-icon color="black">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">
        <span>Brak danych</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger";
import CalendarData from "./CalendarData";
export default {
  name: "schema",
  components: {CalendarData},
  computed: {
    headers() {
      return [
        {text: 'id', align: 'left', sortable: false, value: 'id'},
        {text: 'Szablon nazwy', value: 'name_template'},
        {text: 'Szablon opisu', value: 'description_template'},
        {text: 'Szablon daty', value: 'date_template'},
        {text: 'Szablon godziny', value: 'time_template'},
        {text: 'Kolor', value: 'color'},
      ]
    }
  },
  data(){
    return {
      dialog : false,
      calendarTemplates:[],
      createData:{}
    }
  },
  methods:{
    createTemplate(){
      let payload = this.createData
      if(!this.validate()){
        return
      }
      payload.schema_id = this.$route.params.schemaId

      this.$http.post('calendar-schema', payload).then((data)=>{
        this.calendarTemplates.push(data.data)
        this.dialog = false
      }).catch(()=> Messenger.emitError("Nie można dodać szablonu eventu"))
    },
    validate(){
      if(!this.createData.name_template  || this.createData.name_template.length<3){
        Messenger.emitError("Nazwa musi być zawierać minimum 3 znaki")
        return false
      }
      if(this.createData.date_template.length<4){
        Messenger.emitError("Szablon daty musi zawierać minimum 3 znaki")
        return false
      }
      if(this.createData.time_template.length<3){
        Messenger.emitError("Szablon czasu musi zawierać minimum 3 znaki")
        return false
      }
      if(this.createData.color.length<3){
        Messenger.emitError("Błedny color")
        return false
      }

      return true
    },
    deleteTemplate(id){
      return this.$confirm("Czy na pewno chcesz usunąć szablon?").then(res=>{
        if(res){
          this.$http.delete(`calendar-schema/${id}`).then(()=>{
            this.calendarTemplates = this.calendarTemplates.filter(el => el.id != id)
          }).catch(()=>{
            Messenger.emitError("Nie można usunąć szablonu")
          })
        }
      })

    }
  },
  created() {
    this.$http.get('calendar-schema/schema/' + this.$route.params.schemaId).then(data=>{
      this.calendarTemplates = data.data
    })
  }

}
</script>

<style scoped>

</style>